// extracted by mini-css-extract-plugin
export default {"root":"applications-components-ProductsApp-components-Menu-menu-module__root","menu":"applications-components-ProductsApp-components-Menu-menu-module__menu","slider":"applications-components-ProductsApp-components-Menu-menu-module__slider"};
    if(module.hot) {
      // 1791528099455
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  